<div class="form-floating my-3 col-lg-6">
  <input
    class="form-control"
    placeholder="Pick Date Range"
    readonly
    [value]="dateRangeValue"
    (click)="openRangePicker()"
  />
  <label>Pick Date Range</label>
</div>

<div
  class="p-2"
  [ngClass]="largeView ? 'd-flex gap-2 flex-wrap' : 'row row-cols-1 pb-5'"
>
  @if (generalDataList?.length) {
    <div class="analytics-card">
      <div class="fs-6 px-1 border-2 py-2 d-flex align-items-center">
        <div class="fw-semibold text-primary">General</div>
      </div>
      <table
        class="table table-responsive"
        [ngClass]="generalDataList.length > 1 ? '' : 'table-borderless'"
      >
        <tbody>
          @for (item of generalDataList; track $index) {
            <tr>
              <td>{{ item?.name }}</td>
              <td>{{ item?.value }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <!-- <ng-container *ngIf="clientWiseDataPresent">
    <div [class.mobile-table-overflow]="!largeView" class="col analytics-card">
      <div
        (click)="
          analyticsDataDict?.clientCompletedJobDict?.countExists
            ? null
            : getIndividualAnalytics('client_jobs')
        "
        [class.cursor-pointer]="
          !analyticsDataDict?.clientCompletedJobDict?.countExists
        "
        class="fs-6 px-1 border-2 py-2 d-flex align-items-center"
        >
        <div class="fw-semibold text-primary">Jobs Completed - Client</div>
        @if(!analyticsDataDict?.clientCompletedJobDict?.countExists){
          <div class="ms-2">
            <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
          </div>
        }
      </div>
      @if(analyticsDataDict?.clientCompletedJobDict?.countExists){

        <gtapp-gt-table
        [desktopTableBackendData]="
          analyticsDataDict?.clientCompletedJobDict?.listData
        "
        [desktopTableDetails]="
          analyticsDataDict?.clientCompletedJobDict?.tableDetail
        "
          [otherParams]="analyticsDataDict?.clientCompletedJobDict?.otherParams"
          (paginationChange)="onChangeAnalyticPagination($event, 'client_jobs')"
          (searchColumn)="onSearchIndividualAnalytic($event, 'client_jobs')"
          (sortColumn)="onSortIndividualAnalytic($event, 'client_jobs')"
          >
          </gtapp-gt-table
          >}
        </div>
      </ng-container>

      <ng-container *ngIf="userWiseDataPresent">
        <div [class.mobile-table-overflow]="!largeView" class="col analytics-card">
          <div
        (click)="
          analyticsDataDict?.userCompletedJobDict?.countExists
            ? null
            : getIndividualAnalytics('user_jobs')
        "
        [class.cursor-pointer]="
          !analyticsDataDict?.userCompletedJobDict?.countExists
        "
            class="fs-6 px-1 border-2 py-2 d-flex align-items-center"
            >
            <div class="fw-semibold text-primary">Jobs Completed - User</div>
            @if(!analyticsDataDict?.userCompletedJobDict?.countExists){
              <div class="ms-2">
                <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
              </div>
            }
          </div>
          @if(analyticsDataDict?.userCompletedJobDict?.countExists){

            <gtapp-gt-table
        [desktopTableBackendData]="
          analyticsDataDict?.userCompletedJobDict?.listData
        "
        [desktopTableDetails]="
          analyticsDataDict?.userCompletedJobDict?.tableDetail
        "
              [otherParams]="analyticsDataDict?.userCompletedJobDict?.otherParams"
              (paginationChange)="onChangeAnalyticPagination($event, 'user_jobs')"
              (searchColumn)="onSearchIndividualAnalytic($event, 'user_jobs')"
              (sortColumn)="onSortIndividualAnalytic($event, 'user_jobs')"
              >
              </gtapp-gt-table
              >}
            </div>
          </ng-container> -->
  @for (item of loopTableData; track $index) {
    @if (analyticsDataDict?.[item?.dictKey]?.showItem) {
      <div
        class="col analytics-card"
        [ngClass]="largeView ? 'min-width-content' : 'mobile-table-overflow'"
      >
        <div
          (click)="
            analyticsDataDict?.[item?.dictKey]?.countExists
              ? null
              : getIndividualAnalytics(item?.dataKey)
          "
          [class.cursor-pointer]="
            !analyticsDataDict?.[item?.dictKey]?.countExists
          "
          class="fs-6 px-1 border-2 py-2 d-flex align-items-center"
        >
          <div class="fw-semibold text-primary">{{ item?.header }}</div>
          @if (!analyticsDataDict?.[item?.dictKey]?.countExists) {
            <div class="ms-2">
              <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
            </div>
          }
        </div>
        @if (analyticsDataDict?.[item?.dictKey]?.countExists) {
          @if (
            analyticsDataDict?.[item?.dictKey]?.totalItemCount >
            analyticsDataDict?.[item?.dictKey]?.otherParams?.paginationData
              ?.rows
          ) {
            <gtapp-gt-table
              [desktopTableBackendData]="
                analyticsDataDict?.[item?.dictKey]?.listData
              "
              [desktopTableDetails]="
                analyticsDataDict?.[item?.dictKey]?.tableDetail
              "
              [otherParams]="analyticsDataDict?.[item?.dictKey]?.otherParams"
              (paginationChange)="
                onChangeAnalyticPagination($event, item?.dataKey)
              "
              (searchColumn)="onSearchIndividualAnalytic($event, item?.dataKey)"
              (sortColumn)="onSortIndividualAnalytic($event, item?.dataKey)"
            >
            </gtapp-gt-table>
          } @else {
            <gtapp-gt-table
              [desktopTableUIData]="
                analyticsDataDict?.[item?.dictKey]?.listData
              "
              [desktopTableDetails]="
                analyticsDataDict?.[item?.dictKey]?.tableDetail
              "
              [otherParams]="analyticsDataDict?.[item?.dictKey]?.otherParams"
            >
            </gtapp-gt-table>
          }
        }
      </div>
    }
  }
  @if (
    generalDataDict?.["Tasks Completed"] ||
    generalDataDict?.["Service"] ||
    generalDataDict?.["Scheduled Patrol"] ||
    generalDataDict?.["Static Guard"]
  ) {
    <div [class.mobile-table-overflow]="!largeView" class="col analytics-card">
      <div
        (click)="
          userHoursRosteredDataPulled ? null : getUserHoursRosteredData()
        "
        [class.cursor-pointer]="!userHoursRosteredDataPulled"
        class="fs-6 px-1 border-2 py-2 d-flex align-items-center"
      >
        <div class="fw-semibold text-primary">Hours Rostered</div>
        @if (!userHoursRosteredDataPulled) {
          <div class="ms-2">
            <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
          </div>
        }
      </div>
      @if (userHoursRosteredDataPulled) {
        <gtapp-gt-table
          [desktopTableUIData]="listDataUserHoursRostered"
          [desktopTableDetails]="tableDetailUserHoursRostered"
          [otherParams]="otherParamsUserHoursRostered"
        >
        </gtapp-gt-table>
      }
    </div>
  }

  @if (generalDataDict?.["Inactive Users"]) {
    <div [class.mobile-table-overflow]="!largeView" class="col analytics-card">
      <div
        (click)="inactiveUserList?.length ? null : getAnalyticsData(1)"
        [class.cursor-pointer]="!inactiveUserList?.length"
        class="fs-6 px-1 border-2 py-2 d-flex align-items-center"
      >
        <div class="fw-semibold text-primary">Inactive Users</div>
        @if (!inactiveUserList?.length) {
          <div class="ms-2">
            <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
          </div>
        }
      </div>
      @if (inactiveUserList?.length) {
        <table class="table table-responsive">
          <tbody>
            @for (item of inactiveUserList; track $index) {
              <tr>
                <td>{{ item }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }
</div>
